import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {
    HeaderComponent,
    NavComponent,
    FooterComponent,
    NavigationItem,
    LayoutService
} from '@cvx/nextpage';
import { CalAngularService } from '@cvx/cal-angular';
  import { filter } from 'rxjs';

@Component({
selector: 'app-root',
standalone: true,
imports: [
    RouterOutlet,
    HeaderComponent,
    NavComponent,
    FooterComponent
],
templateUrl: './app.component.html',
styleUrl: './app.component.scss',
encapsulation: ViewEncapsulation.None
})

/**
 * Root shell component.
 * Responsibilities:
 * - Render CVX NextPage shell (header/nav/footer).
 * - Build top-level navigation entries.
 * - Resolve authenticated user display name.
 */
export class AppComponent implements OnInit {
  title = 'bcfo';
  welcome = '';
  navigationItems: NavigationItem[] = [
    {
        label: 'Formula Optimization',
        link: '/formula-optimization'
    },
    {
        label: 'Blend Calculator',
        link: '/blend-calculator'
    }
  ];
  constructor(private authService: CalAngularService, private router: Router, private layout: LayoutService) { }

  ngOnInit()  {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        const name = this.authService.cvxClaimsPrincipal?.name;
        this.welcome = name ? `Welcome ${name}` : '';
      });

    this.layout.toggleFullWidth();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}
